import React from 'react';
import {Redirect} from 'react-router-dom';

export const PersonnelAppConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path: '/maintenance-management/people/:id',
            component: React.lazy(() => import('./PersonnelApp'))
        },
        {
            path: '/maintenance-management/people',
            component: () => <Redirect to="/maintenance-management/people/all"/>
        }
    ]
};